import { Component, OnInit, Input, TemplateRef, ViewChild, OnChanges, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Department } from '../Models/Department';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-ph-bhp-configure-department',
  templateUrl: './ph-bhp-configure-department.component.html',
  styleUrls: ['./ph-bhp-configure-department.component.css']
})
export class PhBhpConfigureDepartmentComponent implements OnInit, OnDestroy {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  subscription: Subscription;
  gridData: Department[];
  addDepartmentForm: UntypedFormGroup;
  private editedRowIndex: number;
  userData;
  modalRef: BsModalRef;
  searchText;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  deleteDataItem
  deleterowIndex
  fields: any[] = [{
    field: 'departmentName', title: this.translationKeys.Configure.Department,
    ngTextEditTemplate: {
      type: 'text',
      maxLength: 60
    }
  }];
  pageInfo = {
    items: 'CONFIGURE.DEPARTMENTS',
    itemsPerPageLabel: 'CONFIGURE.PER_PAGE.DEPARTMENTS'
  };
  departmentModelGridEdit: any = new UntypedFormGroup({
    departmentName: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)]))
  });

  constructor(private service: PHBHPFeaturePackageConfigurationService, private layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public translate: TranslateService, public appConfig: AppConfig) { }

  ngOnInit() {
    this.getDepartmentList();
    this.addDepartmentForm = new UntypedFormGroup({
      departmentName: new UntypedFormControl(
        '', Validators.compose([Validators.required, Validators.maxLength(60)]))
    });
    this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {

      this.getDepartmentList();
    })
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getDepartmentList() {
    this.layoutService.showLoader = true;
    this.service.getDepartmentDetails().subscribe((res: Department[]) => {
      this.layoutService.showLoader = false;
      this.gridData = res;
      this.changeLangDepartmentNage();
    });
  }

  changeLangDepartmentNage() {
    this.gridData.forEach((value, index) => {
      if (this.gridData[index].departmentName)
        this.gridData[index].departmentName = this.layoutService.translateText(value.departmentName);
    });
  }

  handlerData({ handler, formGroup, isNew, dataItem, rowIndex }): void {
    this.userData = this.appConfig.userData;
    switch (handler) {
      case 'saveHandler':
        var userId = this.userData.userId;
        var departmentData = formGroup.value;


        if (isNew) {
          departmentData.createdBy = userId;
          this.service.createDepartment(departmentData).subscribe((res: Department) => {
            this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.DEPARTMENT'));
            this.getDepartmentList();
          });
        } else {
          var data = {
            departmentID: dataItem.departmentID,
            departmentName: departmentData.departmentName
          }
          this.service.updateDepartment(dataItem.departmentID, data).subscribe((res: Department) => {
            this.gridData[rowIndex].departmentName = departmentData.departmentName;
            this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.DEPARTMENT'));
            this.getDepartmentList();
          })
        }
        break;
      case 'removeHandler':
        this.openDeleteModal(this.delmodal, dataItem, rowIndex);


        break;
    }
  }
  openDeleteModal(deletemodal: TemplateRef<any>, dataItem, rowIndex) {
    this.deleteDataItem = dataItem
    this.deleterowIndex = rowIndex
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }
  delete() {
    this.service.deleteDepartment(this.deleteDataItem.departmentID).subscribe((res: Department) => {
      // var data: Department[] = JSON.parse(JSON.stringify(this.gridData));
      // data.splice(this.deleterowIndex, 1);
      // this.gridData = data;
      this.getDepartmentList();
    })
  }
  
  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }
}

